import connect from './connect';

export { EnvelopeDetailReportScreen } from './EnvelopeDetailReportScreen';

export default connect;
